@if (contentlet()) { @if (carouselContents?.length > 0) {
<div
  class="swiper-banner default-carousel-class"
  [ngClass]="{ 'full-width-carousel': contentlet().maxWidth.length > 0 }"
>
  <div
    [ngClass]="{
          'animate-navigations': contentlet().animateNavigation.length > 0,
          'animate-pagination': contentlet().animatePagination.length > 0,
          'swiper-slides-padding': contentlet().enableSpace.length > 0,
          'color-navigation-layout-one': +contentlet().navLayout === 1,
          'color-navigation-layout-two': +contentlet().navLayout === 2,
          'center-vertically': contentlet().verticalCenter.length > 0,
        }"
  >
    <swiper [config]="swiperConfig" ngSkipHydration>
      @for (content of carouselContents; track content) {
      <ng-template swiperSlide>
        <custom-dot-cms-content-render [contentlet]="content" />
      </ng-template>
      }
    </swiper>
  </div>
</div>
} }
